<!-- @Version: 1.1.0 -->
<header data-testid="header" cdkMonitorSubtreeFocus  [ngClass]="'fixed-' + (TRANSLATE_PATH.HEADER_FIXED_VARIANT | translateDesign)" >
   <div [ngClass]="(TRANSLATE_PATH.HEADER_SHADOW_ENABLED | translateDesign) == 'true' ? 'shadow-' + (TRANSLATE_PATH.HEADER_SHADOW_VARIANT | translateDesign) : ''" data-testid="shadow">
      <mat-toolbar color="header-top" class="header-top" [class.no-nav]="(TRANSLATE_PATH.HEADER_BURGER_ENABLED | translateDesign) != 'true'" data-testid="header-top">
         <div class="page-wrapper">
            <div class="logo">
               <ng-content select="[left]"></ng-content>
               <div class="burger-menu">
                  <button mat-icon-button (click)="onToggleSidenav()" data-testid="menu-button" [attr.aria-label]="TRANSLATE_PATH.HEADER_MENU_ALT | translateDesign" class="right">
                     <mat-icon>{{TRANSLATE_PATH.HEADER_MENU_ICON | translateDesign}}</mat-icon>
                  </button>
               </div>
               <div class="flex-1 content-container-flex row">
                  <ng-content select="[middle]"></ng-content>
                  <span class="right">
                     <ng-content select="[right]"></ng-content>
                  </span>
               </div>
            </div>
            <ng-content select="[breadcrumb]"></ng-content>
         </div>
      </mat-toolbar>
      @if ((TRANSLATE_PATH.HEADER_BOTTOM_ENABLED | translateDesign) == 'true' || (TRANSLATE_PATH.HEADER_BOTTOM_ENABLED | translateDesign) == TRANSLATE_PATH.HEADER_BOTTOM_ENABLED) {
         <mat-toolbar color="header-bottom" data-testid="header-bottom">
            <div class="page-wrapper">
               <app-nav-list data-testid="header-navlist">
                  <ng-content select="[nav-csv-list]" csv-list></ng-content>
                  <ng-content select="[nav-special-list]" special-list></ng-content>
               </app-nav-list>
            </div>
         </mat-toolbar>
      }
   </div>
</header>